<template lang="pug">
    header
        PromoBar(
            v-if="globalData && !isSimpleMode"
            :sitewideBanner="globalData.sitewideBanner"
        )

        MobileHeader(v-if="$device.isSmall")
        component(
            v-else
            :is="headerComponent"
        )

        Navbar(
            v-if="!isSimpleMode"
        )
</template>

<script>
import Navbar from '@/components/navbar'
import PromoBar from '@/components/promoBar'
// We could probably lazy load this but since most of the traffic is mobile it might not be worth it.
import MobileHeader from './_components/mobileHeader'
const Header1 = () => import(/* webpackChunkName: "header-1" */ './_components/desktop/header1')
const Header2 = () => import(/* webpackChunkName: "header-2" */ './_components/desktop/header2')

export default {
    components: {
        MobileHeader,
        Navbar,
        PromoBar,
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
        globalData() {
            return this.$globalData || {}
        },
        headerComponent() {
            switch (this.$config.runtime.theme.header.id) {
                case 2:
                    return Header2

                default:
                    return Header1
            }
        },
    },
}
</script>
